import(/* webpackMode: "eager" */ "/codebuild/output/src1412127501/src/doomum-frontend/src/app/[locale]/(client)/error.tsx");
